import * as Sentry from '@sentry/vue'

import { useProfile } from '@/entities/profile'

/**
 * Обработчик 403 ошибки (Forbidden)
 * Обрабатывает различные сценарии запрещённого доступа
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const forbiddenErrorHandler = async (response: Response) => {
  // @ts-expect-error mismatch response types
  Sentry.captureEvent({ message: 'Forbidden error', contexts: { response } })

  const { refreshProfile, logout } = useProfile()

  if (response.status === 403) {
    try {
      const responseClone = response.clone()
      const responseText = await responseClone.text()

      if (responseText) {
        const responseData = JSON.parse(responseText)

        // Пользователь заблокирован - выполняем logout
        if (responseData?.detail === 'User is blocked') {
          await logout('/auth/sign-in')
          return response
        }

        if (responseData?.detail === 'Forbidden') {
          try {
            await refreshProfile()
            window.location.reload()
          } catch (error) {
            console.error('Failed to refresh profile on Forbidden error:', error)
            await logout('/auth/sign-in')
          }
          return response
        }

        // Операция не разрешена - редирект на главную
        if (responseData?.detail === 'Operation not permitted') {
          window.location.href = '/'
          return response
        }
      }
    } catch (error) {
      console.error('Failed to handle forbidden error:', error)
    }
  }

  return response
}
